import React from 'react';
import { Block } from '../../core';
import { assert, assertExhaustive, type CustomBlockTypeEnum, isHoldingsBreakdownBlock } from 'venn-utils';

interface HoldingsCalculationInfoProps {
  blockType: CustomBlockTypeEnum;
}

export const HoldingsCalculationInfo = ({ blockType }: HoldingsCalculationInfoProps) => {
  return <Block.MetadataItem iconType="info-circle">{getCalculationInfo(blockType)}</Block.MetadataItem>;
};

const getCalculationInfo = (blockType: CustomBlockTypeEnum) => {
  assert(isHoldingsBreakdownBlock(blockType));
  switch (blockType) {
    case 'GEOGRAPHY_EXPOSURE':
    case 'SECTOR_EXPOSURE':
    case 'CREDIT_BREAKDOWN':
    case 'MATURITY_BREAKDOWN':
    case 'DURATION_BREAKDOWN':
      return 'Long Rescaled Values';
    case 'ASSET_EXPOSURE':
      return 'Net Rescaled Values';
    default:
      return assertExhaustive(blockType);
  }
};
